import { TypeFiesta, ThemeSelectors } from "@at/design-system-foundation";
import styled, { css } from "styled-components";

import { PrintStyleSheet } from "../../seller/advert-seller-details/location/location.styles";

const displayStyles = css`
  ${({ theme }) => `
    
        position: absolute;
        right: ${ThemeSelectors.getGroupFourSpacing(theme)};
        background: ${ThemeSelectors.getWhite(theme)};
        outline: none;
        border: 1px solid ${ThemeSelectors.getGrey(theme)};
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 999em;
        padding: 8px 16px;
        bottom: 20px;
        height: 40px;
        z-index: 1;

        &:hover {
            background: ${ThemeSelectors.getLightGrey(theme)};
        } 
    `}
`;

export const GalleryGridFpaViewImages = styled.button<{
  forceDisplay?: boolean;
}>`
    display: none;
    cursor: pointer;

    ${({ forceDisplay }) => forceDisplay && displayStyles}}

    @media (min-width: 768px) {
        ${displayStyles}
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 2px #29dcff;
    }

    svg {
        margin-right: 4px;
    }

    ${PrintStyleSheet}
`;

export const ViewMoreButton = styled(TypeFiesta).attrs({
  as: "span",
  weight: 400,
})`
  margin-top: 2px;
`;
